export default class QueryOrganizationsRequest {
  TypeId: string | null = null;
  Status: number[] = [];
}
